import request from "../utils/request";
// url 比后台实际的RequestMapping多一个前缀 (此处多一个forecast)
// 此处多写一个前缀，是因为后台gateway模块拦截到请求会自动截掉第一个前缀
export default {
  /**
   *
   * @param {*} school_name // 学校
   * @param {*} major_name // 专业
   */
  ProRank(params) {
    return request({
      url: `/forecast/forecast/getRole`,
      method: "get",
      params,
    });
  },

  test() {
    return request({
      url: `/forecast/forecast/test`,
      method: "get",
    });
  },

  //院校就业查询的三个接口
  getAllJyxxSchool(params) {
    return request({
      url: `/forecast/forecast/getAllJyxxSchool`,
      method: "get",
      params,
    });
  },

  getJyxxSchoolById(id) {
    return request({
      url: `/forecast/forecast/getJyxxSchoolById?id=${id}`,
      method: "get",
    });
  },

  getYearById(id) {
    return request({
      url: `/forecast/forecast/getYearById?id=${id}`,
      method: "get",
    });
  },
};
